export enum UserLang {
    EN = 'EN',
    EL = 'EL'
}
